import axios from 'axios'
import Utils from '../../../common/utils';

export default {
  getReport: function (parameters) {
    return axios.get('/api/analytics/vacancy/report', {params: parameters});
  },
  exportReport: function(parameters) {
    return Utils.downloadFile('/api/analytics/vacancy/exportreport', "ReportVacancy.xlsx", parameters);
  },
  getReportFields: function() {
    return axios.get('/api/analytics/vacancy/fields');
  }
}